if (!customElements.get('bp-inline-product-video')) {
  customElements.define('bp-inline-product-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.connected) return;
      this.connected = true;
      this.userPaused = false;
      this.inViewport = false;
      this.automaticPause = false;
      this.lastControlInteraction = -Infinity;
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.loop = true;
      this.sync = () => {
        if (!this.canPlay()) {
          this.pauseAutomatically();
        } else if (!this.userPaused && !this.motionPreference.matches) {
          const play = this.video.play();
          if (play) play.catch(() => {});
        }
      };
      this.onPause = () => {
        if (this.automaticPause) {
          this.automaticPause = false;
        } else if (this.canPlay() && performance.now() - this.lastControlInteraction < 1500) {
          this.userPaused = true;
        } else {
          requestAnimationFrame(this.sync);
        }
      };
      this.onControlInteraction = () => {
        this.lastControlInteraction = performance.now();
      };
      this.onPlay = () => {
        this.userPaused = false;
        this.automaticPause = false;
        if (!this.canPlay()) this.pauseAutomatically();
      };
      this.onMotionChange = () => {
        this.video.autoplay = !this.motionPreference.matches;
        if (this.motionPreference.matches) this.pauseAutomatically();
        else this.sync();
      };
      this.video.addEventListener('pause', this.onPause);
      this.video.addEventListener('play', this.onPlay);
      this.video.addEventListener('pointerdown', this.onControlInteraction);
      this.video.addEventListener('keydown', this.onControlInteraction);
      document.addEventListener('visibilitychange', this.sync);
      this.motionPreference.addEventListener('change', this.onMotionChange);
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.inViewport = entries.some(entry => entry.isIntersecting);
        this.sync();
      }, { threshold: 0.05 });
      this.intersectionObserver.observe(this);
      this.slideObserver = new MutationObserver(this.sync);
      const slide = this.closest('.productView-image');
      if (slide) {
        this.slideObserver.observe(slide, {
          attributes: true,
          attributeFilter: ['class', 'aria-hidden', 'style']
        });
      }
      this.onMotionChange();
    }

    canPlay() {
      const slide = this.closest('.productView-image');
      return this.inViewport && !document.hidden &&
        !slide?.classList.contains('slick-cloned') &&
        slide?.getAttribute('aria-hidden') !== 'true';
    }

    pauseAutomatically() {
      if (this.video && !this.video.paused) {
        this.automaticPause = true;
        this.video.pause();
      }
    }

    disconnectedCallback() {
      if (!this.connected) return;
      this.pauseAutomatically();
      this.video.removeEventListener('pause', this.onPause);
      this.video.removeEventListener('play', this.onPlay);
      this.video.removeEventListener('pointerdown', this.onControlInteraction);
      this.video.removeEventListener('keydown', this.onControlInteraction);
      document.removeEventListener('visibilitychange', this.sync);
      this.motionPreference.removeEventListener('change', this.onMotionChange);
      this.intersectionObserver.disconnect();
      this.slideObserver.disconnect();
      this.connected = false;
    }
  });
}
